// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartJewelleryExistingCustomerDocument = `
    mutation addToCartJewelleryExistingCustomer($input: DesignStudioJewelleryInput!) {
  createDesignStudioProductAndAddToCartJewelleryExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useAddToCartJewelleryExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartJewelleryExistingCustomerMutation, SchemaTypes.AddToCartJewelleryExistingCustomerMutationVariables>(AddToCartJewelleryExistingCustomerDocument);
};